import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react'
import ErrorHandler from '../../lib/errorHandler';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import FilterListIcon from '@mui/icons-material/FilterList';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import NoDataFound from '../../Component/Common/NoDataFound';
import StyledTableRow from '../../Component/Common/StyledTableRow';
import IconBackground from '../../Component/Common/IconBackground';
import StyledTableCell from '../../Component/Common/StyledTableCell';
import CommonPagination from '../../Component/Common/CommonPagination';
import { Title, useCommonStyles } from '../../utils';
import { Badge, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import AddNewUserAndRole from '../../Component/UserAndRole/AddNewUserAndRole';
import CustomDrawer from '../../Component/Common/CustomDrawer';
import ViewUserRole from '../../Component/UserAndRole/ViewUserRole';
import { getRoleManagement, getRoleManagementById } from '../../Redux/Actions/RoleManagement';
import CommonSearchField from '../../Component/Common/CommonSearchField';

const UserAndRole = () => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // =============== States ===============
    const [page, setPage] = useState(1);
    const [selectedItem, setSelectedItem] = useState({});
    const [listData, setListData] = useState({});
    const [isOpenAddNewUserRole, setIsOpenAddNewUserRole] = useState(false);
    const [data, setData] = useState({})
    const [isOpenViewDrawer, setIsOpenViewDrawer] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [permissionList, setPermissionList] = useState([
        { "sectionName": "Vendor Management", "view": false, "edit": false },
        { "sectionName": "Inventory Management", "view": false, "edit": false },
        { "sectionName": "Purchase Order", "view": false, "edit": false },
        { "sectionName": "Documents", "view": false, "edit": false },
        { "sectionName": "Invoice", "view": false, "edit": false },
        { "sectionName": "Purchase Entry", "view": false, "edit": false },
        { "sectionName": "Processing", "view": false, "edit": false },
    ]);
    const [searchValue, setSearchValue] = useState('');
    const [isOpenFilterDrawer, setIsOpenFilterDrawer] = useState(false);

    const initialFilterState = {
        role: [],
    };

    const [filterData, setFilterData] = useState(initialFilterState)
    const [isApllyFilter, setIsApplyFilter] = useState(1);

    const filterDataCount = (filterData?.role?.length > 0 ? filterData?.role?.length : 0)

    // =============== Handler ===============
    const roleOptions = [
        { name: "Admin", id: 1 },
        { name: "HR", id: 2 },
        { name: "Manager", id: 3 },
    ];
    let PerPage = 10
    const tabelHeader = ["SR.", "Role", "User Name", "Email Id", "Action"]

    const handleChangePage = (e, p) => {
        setPage(p);
    };

    // ============= get Inventories API =============
    const _getRoleManagement = async (p) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "limit": PerPage,
            "page": p ? p : page,
            "search": searchValue,
            "role": isApllyFilter ? (filterData?.role?.length > 0 ? filterData?.role : null) : null
        }
        response = await dispatch(getRoleManagement(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Get By Id Inventory Field API =============
    const _getRoleManagementById = async (id, isView) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getRoleManagementById(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                const res = response?.payload?.data?.response
                const getRole = roleOptions?.find((ele) => ele?.name == res?.role)
                setSelectedItem(response?.payload?.data?.response)
                setData({
                    ...data,
                    "userName": res?.userName,
                    "emailId": res?.email,
                    "role": getRole,
                })
                const updatedPermissions = permissionList.map((item) => {
                    const matchedPermission = res.permission.find(
                        (perm) => perm.sectionName === item.sectionName
                    );
                    return matchedPermission
                        ? { ...item, view: matchedPermission.view, edit: matchedPermission.edit }
                        : item;
                });
                setPermissionList(updatedPermissions);
                setSelectedRows(res?.permission)
                if (isView) {
                    setIsOpenViewDrawer(true)
                } else {
                    setIsOpenAddNewUserRole(true)
                }
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    const handleCloseViewDrawer = () => {
        setIsOpenViewDrawer(false)
        setData({})
        setSelectedItem({})
        _getRoleManagement()
        setSelectedRows([])
        const resetPermissionList = permissionList?.map((ele) => {
            return {
                ...ele,
                edit: false,
                view: false,
            }
        })
        setPermissionList(resetPermissionList)
    }

    // =============== Use Effects ===============
    useEffect(() => {
        if (searchValue) {
            _getRoleManagement();
        } else {
            _getRoleManagement();
        }
    }, [page, searchValue])   
     useEffect(() => {
        setPage(1);
    }, [searchValue]);
    useEffect(() => {
        setPage(1)
        _getRoleManagement(1);
    }, [isApllyFilter])

    return (
        <>
            {isOpenAddNewUserRole ?
                <AddNewUserAndRole setSearchValue={setSearchValue} roleOptions={roleOptions} setSelectedRows={setSelectedRows} selectedRows={selectedRows} setPermissionList={setPermissionList} permissionList={permissionList} setIsOpenAddNewUserRole={setIsOpenAddNewUserRole} setData={setData} data={data} _getRoleManagement={_getRoleManagement} selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
                :
                <Grid container spacing={2} padding={"25px"}>
                    <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>User & Role</Typography>
                        <Box display={"flex"} gap={1} flexWrap={'wrap'}>
                            <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["User Name", 'Email Id']} />
                            <Badge badgeContent={filterDataCount || 0} sx={{ "& .MuiBadge-badge": { right: "4px", top: "10px", zIndex: 999, color: "#FFF" } }} color="primary">
                                <Button className={classes.cancelButton} startIcon={<FilterListIcon />} onClick={() => setIsOpenFilterDrawer(true)}>Filters </Button>
                            </Badge>
                            <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenAddNewUserRole(true)}>Add New Role</Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                            <TableContainer>
                                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                    <TableHead>
                                        <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                            {tabelHeader?.map((ele) => {
                                                return (
                                                    <StyledTableCell>{ele}</StyledTableCell>
                                                )
                                            })}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listData?.response?.length > 0 ?
                                            listData?.response?.map((row, index) => (
                                                <React.Fragment key={index}>
                                                    <StyledTableRow>
                                                        <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                        <StyledTableCell> {row.role ? row.role : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row.userName ? row.userName : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row.email ? row.email : "NA"}</StyledTableCell>
                                                        <StyledTableCell>
                                                            <Box display={"flex"} gap={1}>
                                                                <IconBackground icon={"visibility"} onClick={() => _getRoleManagementById(row?._id, true)} />
                                                                <IconBackground icon={"edit"} onClick={() => _getRoleManagementById(row?._id, false)} />
                                                            </Box>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                </React.Fragment>
                                            ))
                                            :
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={12}>
                                                    <NoDataFound />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <CommonPagination
                                totalCount={listData?.count}
                                count={Math.ceil(listData?.count / PerPage)}
                                itemsPerPage={PerPage}
                                page={page}
                                onChange={handleChangePage}
                            />
                        </Box>
                    </Grid>
                    <CustomDrawer
                        isDrawerOpen={isOpenViewDrawer}
                        handleClose={() => handleCloseViewDrawer()}
                        title="User & Role"
                    >
                        <ViewUserRole setIsOpenViewDrawer={setIsOpenViewDrawer} selectedItem={selectedItem} />
                    </CustomDrawer>
                    <CustomDrawer
                        isOnlyIconClose
                        isDrawerOpen={isOpenFilterDrawer}
                        handleClose={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1); }}
                        title="Filter"
                    >
                        <Grid container p={2}>
                            <Grid item xs={12}>
                                <Title>Role</Title>
                            </Grid>
                            {roleOptions.map((ele) => {
                                const isChecked = filterData.role.includes(ele?.name);
                                return (
                                    <Grid item xs={12} sm={6} md={4} key={ele}>
                                        <FormControl component="fieldset">
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={isChecked}
                                                            onChange={(e) => {
                                                                setFilterData((prev) => ({
                                                                    ...prev,
                                                                    role: e.target.checked
                                                                        ? [...prev.role, ele?.name]
                                                                        : prev.role.filter((item) => item !== ele?.name)
                                                                }));
                                                            }}
                                                        />
                                                    }
                                                    sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                    label={ele?.name}
                                                    labelPlacement="end"
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                );
                            })}
                            <Grid item xs={12} mt={2} display="flex" justifyContent="end" gap={2}>
                                <Button className={classes.cancelButton}
                                    onClick={() => {
                                        setFilterData(initialFilterState);
                                        //  setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1);
                                    }}>
                                    Reset Filter
                                </Button>
                                <Button className={classes.saveButton} onClick={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1); }}>
                                    Apply Filter
                                </Button>
                            </Grid>
                        </Grid>
                    </CustomDrawer>
                </Grid>
            }
        </>
    )
}

export default UserAndRole